import React from 'react';
import { Alert } from 'react-bootstrap';

const ErrorBoundaryAlert = () => {
    return (
        <Alert variant='danger'>
            Error Occured! Please be patient!
        </Alert>
    )
}

export default ErrorBoundaryAlert;
